import { render, staticRenderFns } from "./addInMan.vue?vue&type=template&id=2c07048a&scoped=true&"
import script from "./addInMan.vue?vue&type=script&lang=js&"
export * from "./addInMan.vue?vue&type=script&lang=js&"
import style0 from "./addInMan.vue?vue&type=style&index=0&id=2c07048a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07048a",
  null
  
)

export default component.exports